import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for payment notes table.
 * @extends JetView
 */
export default class tablePagoNotaCobroView extends JetView {
    /**
     * Configures the view layout and data.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var datos = [
            // Sample data for the list
            { id: '1', State: 'A', balance: '678,79', lastEvent: 'Apuesta' },
            { id: '2', State: 'I', balance: '511,495', lastEvent: 'Recaudo' },
            { id: '3', State: 'A', balance: '319,352', lastEvent: 'Imprimio' },
        ];
        return {
            view: 'list', // View type
            height: 600, // Height of the list
            id: 'listData', // Unique identifier for the list
            template: function (obj) {
                // Template function for rendering list items
                if (obj.State == 'I') {
                    // Check if the state is 'I'
                    return (
                        "<span style='padding-left: 50px; font-size:28px; font-style:arial; text-align: left; line-height:10px;'><span class='icon-iid'></span> ID: " +
                        obj.id +
                        '</span>' +
                        "<span style='padding-left: 100px; font-size:28px; font-style:arial; text-align: left; line-height:50px;'><span class='icon-sstate'></span> ESTADO: <span class='icon-display-A'></span></span>" +
                        "<span style='padding-left: 100px; font-size:28px; font-style:arial; text-align: left; line-height:50px;'><span class='icon-mooney'></span> SALDO: " +
                        obj.balance +
                        '</span>' +
                        "<span style='padding-left: 100px; font-size:28px; font-style:arial; text-align: left; line-height:50px;'><span class='icon-piee-chart'></span> ULTIMO EVENTO: " +
                        obj.lastEvent +
                        '</span>'
                    );
                } else {
                    if (obj.State == 'A') {
                        // Check if the state is 'A'
                        return (
                            "<span style='padding-left: 50px; font-size:28px; font-style:arial; text-align: left; line-height:10px;'><span class='icon-iid'></span> ID: " +
                            obj.id +
                            '</span>' +
                            "<span style='padding-left: 100px; font-size:28px; font-style:arial; text-align: left; line-height:50px;'><span class='icon-sstate'></span> ESTADO: <span class='icon-display-I'></span></span>" +
                            "<span style='padding-left: 100px; font-size:28px; font-style:arial; text-align: left; line-height:50px;'><span class='icon-mooney'></span> SALDO: " +
                            obj.balance +
                            '</span>' +
                            "<span style='padding-left: 100px; font-size:28px; font-style:arial; text-align: left; line-height:50px;'><span class='icon-piee-chart'></span> ULTIMO EVENTO: " +
                            obj.lastEvent +
                            '</span>'
                        );
                    }
                }
            },
            type: {
                height: 62, // Height of each list item
            },
            select: true, // Enable selection of list items
            data: datos, // Data source for the list
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.on(this.app, 'pointsGraphics:filter', (filterData) => {
            // Event listener for filtering data
            webix
                .ajax() // AJAX request to fetch filtered data
                .headers({
                    'Content-type': 'application/json', // Set content type to JSON
                })
                .post(
                    devConfig.geturlApi() + 'es/Client/GetClients', // API endpoint for fetching clients
                    filterData, // Data to be sent in the request
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handling
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handling
                            var resp = JSON.parse(text); // Parse the response
                            console.log(resp.data); // Log the response data
                            $$('listData').clearAll(); // Clear existing data in the list
                            $$('listData').parse(resp.data); // Parse and display new data in the list
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
